import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { AuthContext } from '../App';

const regioni = ['Abruzzo','Basilicata','Calabria','Campania','Emilia-Romagna','Friuli Venezia Giulia','Lazio','Liguria','Lombardia','Marche','Molise','Piemonte','Puglia','Sardegna','Sicilia','Toscana','Trentino-Alto Adige','Umbria','Valle d\'Aosta','Veneto'];
const settori = ['Manifatturiero','Edilizia','Tecnologia','Servizi','Commercio','Turismo','Agricoltura','Artigianato','Energia','Trasporti','Sanita','Alimentare','Altro'];

export default function ProfilePage() {
  const { user, setUser } = useContext(AuthContext);
  const [form, setForm] = useState({ nome: '', cognome: '', azienda: '', piva: '', telefono: '', regione: '', settore: '', fatturato: '', dipendenti: '' });
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [visuraAnalisi, setVisuraAnalisi] = useState(null);
  const [profileData, setProfileData] = useState(null);

  const token = localStorage.getItem('vi_token');
  const api = axios.create({ baseURL: '/api', headers: { Authorization: `Bearer ${token}` } });

  useEffect(() => {
    api.get('/auth/me').then(res => {
      const u = res.data.user;
      setProfileData(u);
      setForm({ nome: u.nome || '', cognome: u.cognome || '', azienda: u.azienda || '', piva: u.piva || '', telefono: u.telefono || '', regione: u.regione || '', settore: u.settore || '', fatturato: u.fatturato || '', dipendenti: u.dipendenti || '' });
      if (u.visura_analisi) {
        try { setVisuraAnalisi(JSON.parse(u.visura_analisi)); } catch {}
      }
    });
  }, []);

  const saveProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.put('/user/profile', form);
      setUser(prev => ({ ...prev, ...res.data.user }));
      toast.success('Profilo aggiornato!');
    } catch { toast.error('Errore aggiornamento'); }
    setLoading(false);
  };

  const uploadVisura = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== 'application/pdf') { toast.error('Solo file PDF ammessi'); return; }
    if (file.size > 10 * 1024 * 1024) { toast.error('File troppo grande (max 10MB)'); return; }

    setUploading(true);
    const formData = new FormData();
    formData.append('visura', file);

    try {
      const res = await api.post('/user/visura', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Visura caricata con successo!');
      if (res.data.analisi) setVisuraAnalisi(res.data.analisi);
      setProfileData(prev => ({ ...prev, visura_path: res.data.path }));
    } catch (err) {
      toast.error(err.response?.data?.error || 'Errore upload');
    }
    setUploading(false);
  };

  return (
    <div className="fade-in" style={{ padding: '30px 0' }}>
      <div className="container" style={{ maxWidth: 800 }}>
        <h1 style={{ marginBottom: 24 }}>Profilo Aziendale</h1>

        {/* Profile Form */}
        <div className="card" style={{ marginBottom: 24 }}>
          <h3 style={{ marginBottom: 16 }}>Dati Azienda</h3>
          <form onSubmit={saveProfile}>
            <div className="grid-2">
              <div className="form-group">
                <label>Nome</label>
                <input value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} />
              </div>
              <div className="form-group">
                <label>Cognome</label>
                <input value={form.cognome} onChange={e => setForm({...form, cognome: e.target.value})} />
              </div>
            </div>
            <div className="grid-2">
              <div className="form-group">
                <label>Ragione Sociale</label>
                <input value={form.azienda} onChange={e => setForm({...form, azienda: e.target.value})} placeholder="Nome azienda" />
              </div>
              <div className="form-group">
                <label>P.IVA</label>
                <input value={form.piva} onChange={e => setForm({...form, piva: e.target.value})} placeholder="01234567890" />
              </div>
            </div>
            <div className="form-group">
              <label>Telefono</label>
              <input value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="+39..." />
            </div>
            <div className="grid-2">
              <div className="form-group">
                <label>Regione</label>
                <select value={form.regione} onChange={e => setForm({...form, regione: e.target.value})}>
                  <option value="">Seleziona...</option>
                  {regioni.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Settore</label>
                <select value={form.settore} onChange={e => setForm({...form, settore: e.target.value})}>
                  <option value="">Seleziona...</option>
                  {settori.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div className="grid-2">
              <div className="form-group">
                <label>Fatturato Annuo</label>
                <select value={form.fatturato} onChange={e => setForm({...form, fatturato: e.target.value})}>
                  <option value="">Seleziona...</option>
                  <option value="0-100k">Fino a 100.000</option>
                  <option value="100k-500k">100.000 - 500.000</option>
                  <option value="500k-2M">500.000 - 2.000.000</option>
                  <option value="2M-10M">2.000.000 - 10.000.000</option>
                  <option value="10M+">Oltre 10.000.000</option>
                </select>
              </div>
              <div className="form-group">
                <label>Dipendenti</label>
                <select value={form.dipendenti} onChange={e => setForm({...form, dipendenti: e.target.value})}>
                  <option value="">Seleziona...</option>
                  <option value="1-9">1-9</option>
                  <option value="10-49">10-49</option>
                  <option value="50-249">50-249</option>
                  <option value="250+">250+</option>
                </select>
              </div>
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Salvataggio...' : 'Salva Profilo'}
            </button>
          </form>
        </div>

        {/* Visura Upload */}
        <div className="card" style={{ marginBottom: 24 }}>
          <h3 style={{ marginBottom: 16 }}>Visura Camerale</h3>
          <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 16 }}>
            Carica la visura camerale della tua azienda in formato PDF. La nostra IA analizzerà automaticamente il documento.
          </p>

          {profileData?.visura_path ? (
            <div className="upload-zone active">
              <div style={{ fontSize: 36, marginBottom: 8 }}>&#10003;</div>
              <p style={{ color: '#16a34a', fontWeight: 600 }}>Visura caricata con successo</p>
              <p style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>{profileData.visura_path}</p>
              <label style={{ marginTop: 12, display: 'inline-block' }}>
                <span className="btn btn-sm btn-outline" style={{ cursor: 'pointer' }}>Carica nuova visura</span>
                <input type="file" accept=".pdf" onChange={uploadVisura} style={{ display: 'none' }} />
              </label>
            </div>
          ) : (
            <label className="upload-zone" style={{ display: 'block' }}>
              <div style={{ fontSize: 36, marginBottom: 8 }}>&#128196;</div>
              <p style={{ fontWeight: 600 }}>{uploading ? 'Caricamento in corso...' : 'Clicca per caricare la visura camerale'}</p>
              <p style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>Formato PDF, max 10MB</p>
              <input type="file" accept=".pdf" onChange={uploadVisura} style={{ display: 'none' }} disabled={uploading} />
            </label>
          )}

          {/* AI Analysis Results */}
          {visuraAnalisi && (
            <div style={{ marginTop: 20, padding: 16, background: '#f0f4ff', borderRadius: 8 }}>
              <h4 style={{ marginBottom: 12, color: '#1a56db' }}>Analisi IA della Visura</h4>
              <div className="grid-2" style={{ gap: 8 }}>
                {Object.entries(visuraAnalisi).filter(([k]) => k !== 'incentivi_suggeriti').map(([key, val]) => (
                  <div key={key} style={{ fontSize: 13 }}>
                    <strong style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}:</strong> {val || 'N/D'}
                  </div>
                ))}
              </div>
              {visuraAnalisi.incentivi_suggeriti?.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <strong style={{ fontSize: 13 }}>Incentivi Suggeriti dall'IA:</strong>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                    {visuraAnalisi.incentivi_suggeriti.map((s, i) => (
                      <span key={i} style={{ background: '#dbeafe', color: '#1e40af', padding: '4px 10px', borderRadius: 20, fontSize: 12 }}>{s}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
